import { createContext } from 'react';

export interface User {
  uuid: string;
}

export const UserContext = createContext<User | null>(null);
